import {store} from './../../redux/';
import { call, put } from 'redux-saga/effects';
import { url } from './../../services/Url';
import CONSTANTS from '../../util/constants';
import APICallingService from '../../services/APICallingService';

const createMoveAPI = (value) => {

    let s = store.getState();
    return APICallingService.sendRequestForPostWithAuth(url.addMove, value, false, (res) => {
    }, true);
}

function* createMove(action) {

    try {
        let s = store.getState();

        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });

        const response = yield call(createMoveAPI, action.payload.value);
        if (response && response?.callBackStatus.toLowerCase() == 'success' && !response.error && response?.data != null) {

            if ((response?.data?.status === undefined && response?.data?.status === null) || response?.data?.status !== 501) {
                if (action.payload.value.driver_id != null && action.payload.value.driver_id != '' && !action.payload.value.move_id) {
                    action.payload.value.move_id = response.data.move_id;
                    action.payload.value.pending = 0;
                    yield put({ type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.UPDATE_MOVES_API_CALL, payload: { value: action.payload.value } });
                }
                else if (action.payload.value.driver_id != null && action.payload.value.driver_id != '' && action.payload.value?.move_id && action.payload.value?.move_id != '') {

                    if (action.payload.value.changeType == 'OFFSITE_INCOMING' || action.payload.value.changeType == 'OFFSITE_OUTGOING' || action.payload.value.changeType == 'OFFSITE' || action.payload.value.changeType == 'DC2DC') {

                        alert('OffSite added Successfully');

                        let obj = {
                            offSiteType: 2,
                            pageNo: 1,
                            limit: 10,
                        }
                        yield put({ type: CONSTANTS.CONSTANTS_OFFSITE_MANAGEMENT.GET_OFFSITE_DATA_API_CALL, payload: { value: obj } });

                    }
                    else {
                        alert('Move added Successfully');

                        let obj = {
                            moveType: 2,
                            pageNo: 1,
                            limit: 10,
                        }
                        yield put({ type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_MOVES_API_CALL, payload: { value: obj } });

                    }
                }
                else {
                    if (action.payload.value.changeType == 'OFFSITE_INCOMING' || action.payload.value.changeType == 'OFFSITE_OUTGOING' || action.payload.value.changeType == 'OFFSITE' || action.payload.value.changeType == 'DC2DC') {
                        alert('OffSite added Successfully');

                        let obj = {
                            offSiteType: 1,
                            pageNo: 1,
                            limit: 10,
                        }
                        yield put({ type: CONSTANTS.CONSTANTS_OFFSITE_MANAGEMENT.GET_OFFSITE_DATA_API_CALL, payload: { value: obj } });

                    }
                    else {
                        alert('Move added Successfully');

                        let obj = {
                            moveType: 1,
                            pageNo: 1,
                            limit: 10,
                        }
                        yield put({ type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_MOVES_API_CALL, payload: { value: obj } });
                    }
                }
            }
            else {
                alert((response?.data?.error != undefined && response?.data?.error != null && response?.data?.error != '') ? response?.data?.error : '', 'Failed to create move ,Please try again');

                if (action.payload.value.changeType == 'OFFSITE_INCOMING' || action.payload.value.changeType == 'OFFSITE_OUTGOING' || action.payload.value.changeType == 'OFFSITE' || action.payload.value.changeType == 'DC2DC') {
                    let obj = {
                        offSiteType: 1,
                        pageNo: 1,
                        limit: 10,
                    }
                    yield put({ type: CONSTANTS.CONSTANTS_OFFSITE_MANAGEMENT.GET_OFFSITE_DATA_API_CALL, payload: { value: obj } });

                    yield put({ type: CONSTANTS.CONSTANTS_OFFSITE_MANAGEMENT.ADD_OFFSITE_API_SUCCESS, payload: { value: [] } });

                }
                else {
                    let obj = {
                        moveType: 1,
                        pageNo: 1,
                        limit: 10,
                    }
                    yield put({ type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_MOVES_API_CALL, payload: { value: obj } });

                    yield put({ type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.ADD_MOVES_API_SUCCESS, payload: { value: [] } });

                }

            }
        }
        else {
            if (action.payload.value.changeType == 'OFFSITE_INCOMING' || action.payload.value.changeType == 'OFFSITE_OUTGOING' || action.payload.value.changeType == 'OFFSITE' || action.payload.value.changeType == 'DC2DC') {
                if (response?.error == 'Validation error') {
                    let obj = {
                        offSiteType: 1,
                        pageNo: 1,
                        limit: 10,
                    }
                    yield put({ type: CONSTANTS.CONSTANTS_OFFSITE_MANAGEMENT.GET_OFFSITE_DATA_API_CALL, payload: { value: obj } });

                    alert('Move already existes selected division')
                }
                else {
                    if (response && response != null && response.Status != 405) {
                        alert('Failed to create move ,Please try again');
                    } yield put({ type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.ADD_MOVES_API_SUCCESS, payload: { value: [] } });

                    let obj = {
                        offSiteType: 1,
                        pageNo: 1,
                        limit: 10,
                    }
                    yield put({ type: CONSTANTS.CONSTANTS_OFFSITE_MANAGEMENT.GET_OFFSITE_DATA_API_CALL, payload: { value: obj } });

                    yield put({ type: CONSTANTS.CONSTANTS_OFFSITE_MANAGEMENT.ADD_OFFSITE_API_SUCCESS, payload: { value: [] } });
                }
            }
            else {
                if (response?.error == 'Validation error') {
                    let obj = {
                        moveType: 1,
                        pageNo: 1,
                        limit: 10,
                    }
                    yield put({ type: CONSTANTS.CONSTANTS_OFFSITE_MANAGEMENT.GET_MOVES_API_CALL, payload: { value: obj } });

                    alert('Move already existes selected division')
                }
                else {
                    let obj = {
                        moveType: 1,
                        pageNo: 1,
                        limit: 10,
                    }
                    yield put({ type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_MOVES_API_CALL, payload: { value: obj } });

                    if (response && response != null && response.Status != 405) {
                        alert('Failed to create move ,Please try again');
                    } yield put({ type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.ADD_MOVES_API_SUCCESS, payload: { value: [] } });

                }
            }
        }


    }
    catch (e) {

        yield put({ type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.ADD_MOVES_API_SUCCESS, payload: { value: [] } });

    }


}

const getDoorForMoveAPI = () => {

    return APICallingService.sendRequestForGet(url.doorsForMoves, (res) => {
    }, true);

}

function* getDoorForMove(action) {

    try {


        let s = store.getState();

        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });

        const response = yield call(getDoorForMoveAPI);

        if (response && response != null && response.data) {


            yield put({
                type: CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.GET_DOORS_FOR_MOVE_MANAGEMENT_API_SUCCESS, payload: { value: response.data }
            })
            yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: false } });

        }
        else {
            if (response && response != null && response.Status != 405) {
                alert('Failed to get Doors');
                yield put({
                    type: CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.GET_DOORS_FOR_MOVE_MANAGEMENT_API_SUCCESS, payload: { value: 'Failed' }
                })
            }
        }
    }
    catch (e) {
        yield put({
            type: CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.GET_DOORS_FOR_MOVE_MANAGEMENT_API_SUCCESS, payload: { value: 'Failed' }
        })
    }


}

const getMoveAPI = (value) => {

    let urlMove = url.getMoveByTypes + value.moveType + "/" + value.pageNo + "/" + value.limit;

    return APICallingService.sendRequestForGet(urlMove, (res) => {
    }, true);

}

function* getMove(action) {

    try {


        let s = store.getState();

        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });

        const response = yield call(getMoveAPI, action.payload.value);

        if (response && response != null) {
            yield put({
                type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_MOVES_API_SUCCESS, payload: { value: response.data }
            })
            yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: false } });

        }
        else {
            if (response && response != null && response.Status != 405) {
                alert('Failed to get move')
                yield put({
                    type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_MOVES_API_SUCCESS, payload: { value: 'Failed' }
                })
            }
        }
    }
    catch (e) {
        yield put({
            type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_MOVES_API_SUCCESS, payload: { value: 'Failed' }
        })
    }


}

const deleteMoveAPI = (value) => {

    return APICallingService.sendRequestForPostWithAuth(url.deleteMove, value, false, (res) => {
    }, true);

}

function* deleteMove(action) {

    try {


        let s = store.getState();

        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });

        const response = yield call(deleteMoveAPI, action.payload.value);

        if (response && response?.callBackStatus.toLowerCase() == 'success') {

            alert('Move deleted Successfully');

            yield put({ type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_MOVES_API_CALL });

        }
        else {
            if (response && response != null && response.Status != 405) {
                alert('Failed to update move');
                yield put({ type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.DELETE_MOVES_API_SUCCESS, payload: { value: [] } });
            }
        }


    }
    catch (e) {
        yield put({ type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.DELETE_MOVES_API_SUCCESS, payload: { value: [] } });
    }


}

const updateMoveAPI = (value) => {

    let s = store.getState();
    let urlMove = url.addMove + "/" + value?.move_id;
    return APICallingService.sendRequestForPut(value, urlMove, (res) => {

    }, true);

}

function* updateMove(action) {

    try {


        let s = store.getState();

        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });

        const response = yield call(updateMoveAPI, action.payload.value);
        if (response && response != null && response.status == 501) {
            alert(response.error);
            if (action.payload.value.changeType == 'OFFSITE_INCOMING' || action.payload.value.changeType == 'OFFSITE_OUTGOING' || action.payload.value.changeType == 'OFFSITE') {
                let obj = {
                    offSiteType: 1,
                    pageNo: 1,
                    limit: 10,
                }
                yield put({ type: CONSTANTS.CONSTANTS_OFFSITE_MANAGEMENT.GET_OFFSITE_DATA_API_CALL, payload: { value: obj } });

            }
            else {
                let obj = {
                    moveType: 1,
                    pageNo: 1,
                    limit: 10,
                }
                yield put({ type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_MOVES_BY_TYPES_API_CALL, payload: { value: obj } });

            }

            yield put({ type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.UPDATE_MOVES_API_SUCCESS, payload: { value: [] } });
            return
        }
        if (response && response?.callBackStatus.toLowerCase() == 'success' && !response?.error) {

            let obj = {};
            if (action.payload.value.pending == true && action.payload.value.completed == false && action.payload.value.is_cancelled == false) {

                if (action.payload.value.changeType == 'OFFSITE_INCOMING' || action.payload.value.changeType == 'OFFSITE_OUTGOING' || action.payload.value.changeType == 'OFFSITE' || action.payload.value.changeType == 'DC2DC') {
                    alert('OffSite updated Successfully');

                    obj = {
                        offSiteType: 1,
                        pageNo: 1,
                        limit: 10,
                    }
                    yield put({ type: CONSTANTS.CONSTANTS_OFFSITE_MANAGEMENT.GET_OFFSITE_DATA_API_CALL, payload: { value: obj } });

                }
                else {
                    alert('Move updated Successfully');

                    obj = {
                        moveType: 1,
                        pageNo: 1,
                        limit: 10,
                    }
                    yield put({ type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_MOVES_BY_TYPES_API_CALL, payload: { value: obj } });

                }
            }
            else if (action.payload.value.pending == false && action.payload.value.completed == false && action.payload.value.is_cancelled == false) {

                if (action.payload.value.changeType == 'OFFSITE_INCOMING' || action.payload.value.changeType == 'OFFSITE_OUTGOING' || action.payload.value.changeType == 'OFFSITE' || action.payload.value.changeType == 'DC2DC') {
                    alert('OffSite updated Successfully');

                    obj = {
                        offSiteType: 2,
                        pageNo: 1,
                        limit: 10,
                    }
                    yield put({ type: CONSTANTS.CONSTANTS_OFFSITE_MANAGEMENT.GET_OFFSITE_DATA_API_CALL, payload: { value: obj } });

                }
                else {
                    alert('Move updated Successfully');

                    obj = {
                        moveType: 2,
                        pageNo: 1,
                        limit: 10,
                    }
                    yield put({ type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_MOVES_BY_TYPES_API_CALL, payload: { value: obj } });

                }
            }
            else if (action.payload.value.pending == false && action.payload.value.completed == true && action.payload.value.is_cancelled == false) {
                if (action.payload.value.changeType == 'OFFSITE_INCOMING' || action.payload.value.changeType == 'OFFSITE_OUTGOING' || action.payload.value.changeType == 'OFFSITE' || action.payload.value.changeType == 'DC2DC') {
                    alert('OffSite Completed Successfully');
                    obj = {
                        offSiteType: 3,
                        pageNo: 1,
                        limit: 10,
                    }
                    yield put({ type: CONSTANTS.CONSTANTS_OFFSITE_MANAGEMENT.GET_OFFSITE_DATA_API_CALL, payload: { value: obj } });

                }
                else {
                    alert('Move Completed Successfully');
                    obj = {
                        moveType: 3,
                        pageNo: 1,
                        limit: 10,
                    }
                    yield put({ type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_MOVES_BY_TYPES_API_CALL, payload: { value: obj } });

                    if (action.payload.value.changeType?.value == 'DC2DC') {

                        let objTrailer = { 'id': action.payload.value.trailer_id, 'btId': '', 'status': 'Active', 'designationLocation': 'RH 521DC', 'purchaseDate': new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date()), division_id: action.payload.value?.divisionToId }

                        yield put({ type: CONSTANTS.CONSTANTS_TRAILER_MANAGEMENT.EDIT_TRAILER_MANAGEMENT_API_CALL, payload: { value: objTrailer } });
                    }


                }
            }
            else {
                if (action.payload.value.changeType == 'OFFSITE_INCOMING' || action.payload.value.changeType == 'OFFSITE_OUTGOING' || action.payload.value.changeType == 'OFFSITE' || action.payload.value.changeType == 'DC2DC') {
                    alert('OffSite Cancelled Successfully');

                    obj = {
                        offSiteType: 4,
                        pageNo: 1,
                        limit: 10,
                    }
                    yield put({ type: CONSTANTS.CONSTANTS_OFFSITE_MANAGEMENT.GET_OFFSITE_DATA_API_CALL, payload: { value: obj } });

                }
                else {
                    alert('Move Cancelled Successfully');

                    obj = {
                        moveType: 4,
                        pageNo: 1,
                        limit: 10,
                    }
                    yield put({ type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_MOVES_BY_TYPES_API_CALL, payload: { value: obj } });
                }
            }

        }
        else {
            if (response && response != null && response.Status != 405) {

                alert('Failed to update move');
                if (action.payload.value.changeType == 'OFFSITE_INCOMING' || action.payload.value.changeType == 'OFFSITE_OUTGOING' || action.payload.value.changeType == 'OFFSITE') {
                    let obj = {
                        offSiteType: 1,
                        pageNo: 1,
                        limit: 10,
                    }
                    yield put({ type: CONSTANTS.CONSTANTS_OFFSITE_MANAGEMENT.GET_OFFSITE_DATA_API_CALL, payload: { value: obj } });

                }
                else {
                    let obj = {
                        moveType: 1,
                        pageNo: 1,
                        limit: 10,
                    }
                    yield put({ type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_MOVES_BY_TYPES_API_CALL, payload: { value: obj } });

                }

                yield put({ type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.UPDATE_MOVES_API_SUCCESS, payload: { value: [] } });
            }
        }


    }
    catch (e) {

        alert('Failed to update move')
        yield put({ type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.UPDATE_MOVES_API_SUCCESS, payload: { value: [] } });

    }


}

const getSpaceFromAPI = () => {

    return APICallingService.sendRequestForGet(url.spaceFrom, (res) => {
    }, true);

}

function* getSpaceFrom(action) {

    try {


        let s = store.getState();

        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });

        const response = yield call(getSpaceFromAPI);

        if (response && response != null) {



            yield put({
                type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_SPACE_FROM_API_SUCCESS, payload: { value: response.data }
            })
            yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: false } });

        }
        else {
            if (response && response != null && response.Status != 405) {
                alert('Failed to get space')
                yield put({
                    type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_SPACE_FROM_API_SUCCESS, payload: { value: 'Failed' }
                })
            }
        }
    }
    catch (e) {
        yield put({
            type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_MOVES_API_SUCCESS, payload: { value: 'Failed' }
        })
    }


}

const getSpaceToAPI = () => {

    return APICallingService.sendRequestForGet(url.spaceTo, (res) => {
    }, true);

}

function* getSpaceTo(action) {

    try {


        let s = store.getState();

        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });

        const response = yield call(getSpaceToAPI);

        if (response && response != null) {

            yield put({
                type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_SPACE_TO_API_SUCCESS, payload: { value: response.data }
            })
            yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: false } });

        }
        else {
            if (response && response != null && response.Status != 405) {

                alert('Failed to get space');
                yield put({
                    type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_SPACE_TO_API_SUCCESS, payload: { value: 'Failed' }
                })
            }
        }
    }
    catch (e) {
        yield put({
            type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_MOVES_API_SUCCESS, payload: { value: 'Failed' }
        })
    }


}

const getMoveByTypesAPI = (value) => {


    let urlMoveType = url.getMoveByTypes + value.moveType + "/" + value.pageNo + "/" + value.limit;
    return APICallingService.sendRequestForGet(urlMoveType, (res) => {
    }, true);

}

function* getMoveByTypes(action) {

    try {

        let s = store.getState();
        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });
        const response = yield call(getMoveByTypesAPI, action.payload.value);
        if (response && response != null && response.data) {

            yield put({
                type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_MOVES_API_SUCCESS, payload: { value: response.data }
            })
            yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: false } });
        }
        else {
            if (response && response != null && response.Status != 405) {
                alert('Failed to get move')
                yield put({
                    type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_MOVES_API_SUCCESS, payload: { value: 'Failed' }
                })
            }
        }
    }
    catch (e) {
        yield put({
            type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_MOVES_API_SUCCESS, payload: { value: 'Failed' }
        })
    }
}


const createContainerAPI = (value) => {
    return APICallingService.sendRequestForPostWithAuth(url.createContainer, value, false, (res) => {
    }, true);
}

function* createContainer(action) {

    try {


        let s = store.getState();

        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });

        const response = yield call(createContainerAPI, action.payload.value);

        if (response && response?.callBackStatus.toLowerCase() == 'success') {

            let obj = {
                searchText: action?.payload?.value?.btId,
                pageNo: 0
            }
            alert('Container Created Successfully');
            yield put({ type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.CREATE_CONTAINER_API_SUCCESS, payload: { value: response.data } });
            yield put({ type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_CONTAINERS_API_CALL, payload: { value: obj } });
        }
        else {
            if (response && response != null && response.Status != 405) {

                alert('Failed to create container , please try again');
                yield put({ type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.CREATE_CONTAINER_API_SUCCESS, payload: { value: 'Failed' } });
            }
        }


    }
    catch (e) {
        yield put({ type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.ADD_MOVES_API_SUCCESS, payload: { value: [] } });
    }


}
export { createContainer, getMove, createMove, deleteMove, updateMove, getDoorForMove, getSpaceFrom, getSpaceTo, getMoveByTypes };
